import { Components } from "@thisgorilla/primate-ds";
import { useContext, useEffect, useState } from "react";
import styled, { useTheme } from "styled-components";

import { HOC } from "../../../../../../HOC";
import { useAppSelector } from "../../../../../../redux";
import { SliderDirection } from "../../../../../../redux/common";
import { ModalContext } from "../../../../../Common/Modal";
import {
  FlexColumn,
  FlexColumnWithTransition,
  FlexRowSpaced,
  verticalScroll,
} from "../../../../../Common/Styles";
import { UserCardWithCommonInterests } from "../../../../../Common/UserCardWithCommonInterests";

export const PeopleYouMightKnowModalContent = () => {
  const { typography, Color } = useTheme();
  const { WithHeightTransition, WithSlider } = HOC;
  const { peopleYouMightKnow } = useAppSelector((state) => state.me);
  const { footerRef, headerRef, contentRef } = useContext(ModalContext);
  const [containerHeight, setContainerHeight] = useState(0);

  const [direction, setDirection] = useState("to-right" as SliderDirection);
  const [currentStep, setCurrentStep] = useState(1);
  const TOTAL_DATA_PER_SLIDE = 3;
  const TOTAL_DATA_LENGTH = peopleYouMightKnow?.length;
  const TOTAL_SLIDES = Math.ceil(TOTAL_DATA_LENGTH / TOTAL_DATA_PER_SLIDE);

  const isFirstSlide = currentStep === 1;
  const isLastSlide = currentStep === TOTAL_SLIDES;
  const startIndex = (currentStep - 1) * TOTAL_DATA_PER_SLIDE;
  const endIndex = startIndex + TOTAL_DATA_PER_SLIDE;

  useEffect(() => {
    headerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [currentStep, headerRef]);

  return (
    <Container $gapInPx={16}>
      <FlexColumn ref={headerRef}>
        <Components.Text
          text="People you might know"
          style={{ tokenStyle: typography.Heading.L }}
          fontWeight="font-weight-medium"
          color={Color.text["text-emphasize-brand-bolder"].value}
        />
        <Description>
          <Components.Text
            text="We’ve curated people that you might know based on your job title, industry, location and interests."
            style={{ tokenStyle: typography.Body.M }}
          />
        </Description>
      </FlexColumn>
      <StepContainer
        className="step-container"
        ref={contentRef}
        $height={containerHeight}
      >
        <WithHeightTransition setContainerHeight={setContainerHeight}>
          <WithSlider
            stepKey={`recommended-people-${currentStep}`}
            direction={direction}
            animationDuration={300}
          >
            <FlexColumn>
              {peopleYouMightKnow
                .slice(startIndex, endIndex)
                .map((user, index) => (
                  <UserCardWithCommonInterests
                    key={`${user.id}-${index}`}
                    showHoverEffect={false}
                    user={user}
                  />
                ))}
            </FlexColumn>
          </WithSlider>
        </WithHeightTransition>
      </StepContainer>
      <FlexRowSpaced ref={footerRef}>
        {!isFirstSlide ? (
          <Components.Button
            kind="Primary"
            size="Medium"
            color="Neutral"
            disabled={false}
            label="Back"
            onClick={() => {
              setCurrentStep(currentStep - 1);
              setDirection("to-left");
            }}
          />
        ) : (
          <div />
        )}
        {!isLastSlide && (
          <Components.Button
            kind="Primary"
            size="Medium"
            color="Primary"
            disabled={false}
            label="Shuffle"
            onClick={() => {
              setCurrentStep(currentStep + 1);
              setDirection("to-right");
            }}
            iconPosition="left"
            iconType="Shuffle"
          />
        )}
      </FlexRowSpaced>
    </Container>
  );
};

const Container = styled(FlexColumn)(
  ({ theme }) => `
  padding: ${theme.spacing["spacing-8"].value}rem;
`
);
const Description = styled.span`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
const StepContainer = styled(FlexColumnWithTransition)`
  ${verticalScroll};
  z-index: 2;
`;
